/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-blockload.html";
import { events } from "@nuskin/ns-util";

export class NsBlockload extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-blockload";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      opened: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      }
    };
  }

  ready() {
    super.ready();
    events.subscribe("toggleBlockload", () => {
      this.toggle();
    });
    events.subscribe("closeBlockload", () => {
      this.hide();
    });
    events.subscribe("openBlockload", () => {
      this.show();
    });
  }

  hide() {
    this.opened = false;
  }

  show() {
    this.opened = true;
  }

  toggle() {
    this.opened ? this.hide() : this.show();
  }
}
customElements.define(NsBlockload.is, NsBlockload);
